import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './Legend.css';

const Legend = (props) => {
    const { data, onClick, onKeyPress, vertical, square, percentOnly } = props;
    return (
        <div
            className={cn(
                'legend',
                { vertical: !!vertical },
                { 'percent-only': percentOnly }
            )}
        >
            {data.map((ele) => (
                <div
                    role="button"
                    tabIndex={0}
                    onClick={onClick}
                    onKeyPress={onKeyPress}
                    className={cn('row', { square })}
                    key={ele.label}
                >
                    <div
                        className={cn('dot', { square })}
                        style={{ backgroundColor: ele.color }}
                    />
                    <div className="text">{ele.label}</div>
                    <div className="text">{ele.value}</div>
                </div>
            ))}
            <style jsx>{styles}</style>
        </div>
    );
};

Legend.defaultProps = {
    vertical: false,
    data: [],
    onClick: () => {},
    onKeyPress: () => {},
    square: false
};

Legend.propTypes = {
    /**
     * Data elements to represent in the legend
     */
    data: PropTypes.instanceOf(Array),
    /**
     * Orientation of the legend
     */
    vertical: PropTypes.bool,
    /**
     * Boolean for legend color shape
     */
    square: PropTypes.bool,
    /**
     * Click event callback
     */
    onClick: PropTypes.func,
    /**
     * Key press callback
     */
    onKeyPress: PropTypes.func
};

export default Legend;
